import * as React from 'react'
import { cn } from '@/lib/utils'

/*
 * Modal: a centred overlay for confirmation and single-decision inputs only.
 * Built on the native <dialog> element so focus trapping, Esc-to-close and
 * focus restoration are handled by the platform. Use a slide-over or full page
 * for editing records or multi-step flows.
 */
function Modal({
  open,
  onClose,
  labelledBy,
  describedBy,
  className,
  children,
}: {
  open: boolean
  onClose: () => void
  labelledBy?: string
  describedBy?: string
  className?: string
  children: React.ReactNode
}) {
  const ref = React.useRef<HTMLDialogElement>(null)

  React.useEffect(() => {
    const dialog = ref.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    else if (!open && dialog.open) dialog.close()
  }, [open])

  return (
    <dialog
      ref={ref}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      onClose={onClose}
      onCancel={(event) => {
        event.preventDefault()
        onClose()
      }}
      onClick={(event) => {
        if (event.target === ref.current) onClose()
      }}
      className={cn(
        'm-auto w-[min(34rem,calc(100vw-2rem))] rounded-lg border border-line bg-surface p-0 text-fg shadow-e3',
        'backdrop:bg-[rgb(8_19_14_/_45%)]',
        className,
      )}
    >
      {open ? <div className="p-5">{children}</div> : null}
    </dialog>
  )
}

export { Modal }
